import { Injectable } from '@angular/core';
import { StatisticsService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataExportJobs } from './data-export-jobs.actions';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import * as selectors from '../reducers/index';
import { getSelected, State, TENANTS } from '../reducers';
import { TenantSelectors } from '../tenants/tenants.selectors';
import { auth } from '../auth/auth.selectors';

@Injectable()
export class DataExportJobsEffects {
  createJob$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(DataExportJobs.RequestCreateAction),
      withLatestFrom(this.store.select(selectors.statistics.getFilters)),
      switchMap(([action, filter]) =>
        this.api
          .createStatsExportJob({
            exportJobRequestDto: {
              ...action.payload,
              startDate: filter?.startDate.toISOString(),
              endDate: filter?.endDate.toISOString(),
            },
          })
          .pipe(
            map((item) => DataExportJobs.ResponseSuccessCreateAction({ payload: item })),
            catchError((error) => of(DataExportJobs.ResponseFailCreateAction({ error }))),
          ),
      ),
    ),
  );

  listJobs$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(DataExportJobs.RequestRetrieveAllAction),
      withLatestFrom(
        this.store.select(TenantSelectors.getSelectedId),
        this.store.select(auth.getLoggedInUser),
      ),
      switchMap(([action, tenantId, user]) =>
        this.api.listExportJobs({ tenantId: tenantId as any, memberId: user?.id }).pipe(
          map((items) => DataExportJobs.ResponseSuccessRetrieveAllAction({ payload: items })),
          catchError((error) => of(DataExportJobs.ResponseFailRetrieveAllAction({ error }))),
        ),
      ),
    ),
  );
  constructor(
    private api: StatisticsService,
    private store: Store<State>,
    private actions$: Actions,
  ) {}
}
